import React from "react";

export default function Section5() {
  const shopifyOnlyServices = [
    {
      title: "Custom Shopify Design",
      description:
        "We build pixel-perfect, custom designs tailored to your brand voice, audience, and product strategy. From typography to animations, every element is crafted for maximum impact.",
    },
    {
      title: "Shopify Store Development",
      description:
        "Our developers code clean, scalable Shopify themes optimized for performance and user experience. Every store we build is mobile-friendly, cross-browser tested, and conversion-focused.",
    },
    {
      title: "Shopify Plus Development",
      description:
        "We help high-volume businesses unlock the full power of Shopify Plus. From custom checkout flows to integrations with ERPs and CRMs, we scale your ecommerce operations smoothly and securely.",
    },
    {
      title: "App Integration and API Work",
      description:
        "Need more than native Shopify features? We handle third-party integrations, custom apps, and advanced API development to make your store do exactly what you need.",
    },
    {
      title: "Migration to Shopify",
      description:
        "We make platform transitions painless. Our team migrates product data, content, customers, and orders from WooCommerce, Magento, BigCommerce, or custom systems without downtime or data loss.",
    },
    {
      title: "Support and Maintenance",
      description:
        "Launching is just the beginning. Our ongoing support includes performance audits, technical maintenance, new feature development, and design updates as your store evolves.",
    },
  ];

  return (
    <div className="w-full Section4 mt-[14%] md:mt-[4%]">
      <div className="w-full mx-auto section4-container">
        <h2 className="w-[90%] md:w-[61%] mx-auto text-center text-[26px] md:text-[34px] leading-[32px] md:leading-[41px] text-[#151515] font-bold my-[0.67em]">
          Our Shopify Development Services
        </h2>

        <div className="boxes w-[85%] xs:w-full md:w-[85%] flex justify-center gap-x-[2%] gap-y-[19px] md:gap-y-[30px] flex-wrap mx-auto p-[2%_0px_4%_0px]">
          {/* Shopify-only Cards */}
          {shopifyOnlyServices.map((service, index) => (
            <div
              key={index}
              className={`w-full xs:w-[45%] md:w-[30%] p-[10%] xs:p-[3%] rounded-[8px] ${
                index % 2 === 0 ? "bg-[#E42E35] text-white" : "bg-[#F5F5F5] text-[#373737]"
              }`}
            >
              <h2 className="md:text-[25px] text-[20px] leading-[24px] font-bold md:leading-[30px] pb-[4%] my-[0.67em]">
                {service.title}
              </h2>
              <p className="mb-5 text-xs md:text-sm leading-[22px] font-open">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
